import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { charmGray } from '../../../../styles/colors';
import { DefaultBorder } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	assistantDefaultMessageContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	contentCalendarGenerationPreviewConfirmationText: {
		color: THEME.colors.text.main,
		fontSize: 14,
	},
	generationForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	contentTypeCheckboxes: {
		display: 'flex',
		gap: THEME.spacing.md,
		flexWrap: 'wrap',
	},
	contentTypeCheckboxRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	contentTypeLabel: {
		fontSize: 14,
		cursor: 'pointer',
	},
	instructionsSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	instructionsLabel: {
		fontSize: 13,
		fontWeight: 500,
		color: THEME.colors.text.light,
	},
	instructionsTextarea: {
		border: DefaultBorder,
		borderRadius: THEME.common.borderRadius,
		padding: '8px 12px',
		fontSize: 14,
		resize: 'vertical',
		minHeight: 60,
		maxHeight: 120,
		outline: 'none',
		fontFamily: 'inherit',
		'::placeholder': {
			color: charmGray,
		},
	},
	preferencesSection: {
		display: 'flex',
		flexDirection: 'column',
		border: DefaultBorder,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
	},
	preferencesToggle: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '8px 12px',
		fontSize: 13,
		fontWeight: 500,
		color: THEME.colors.text.light,
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		width: '100%',
		textAlign: 'left',
	},
	preferencesChevron: {
		display: 'inline-block',
		transition: 'transform 0.2s ease',
		fontSize: 12,
	},
	preferencesChevronExpanded: {
		transform: 'rotate(180deg)',
	},
	preferencesContent: {
		padding: '0 12px 12px',
	},
});
